import {
    Autocomplete,
    Box,
    Dialog,
    Divider,
    TextField,
    Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import React, { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { Education } from "../../model/surveyor_filter_model";
import { Option } from "../../../needs/model/needs_filters";
import {
    FilterDialogFooter,
    FilterDialogHeader,
    PillToggleButton,
} from "../../../users/components/filter_dialog/filter_dialog_parts";

interface FilterForDownloadsInterface {
    status: null | number;
    setStatus: (val: null | number) => void;
    openModal: boolean;
    setOpenModal: (val: boolean) => void;
    startDate: string;
    setStartDate: (value: string) => void;
    endDate: string;
    setEndDate: (value: string) => void;
    schemeKeyword: string;
    setSchemeKeyword: (value: string) => void;
    states: Education[];
    stateId: number | null;
    setStateId: (val: number | null) => void;
    categoryId: number | null;
    setCategoryId: (val: number | null) => void;
    resetFilter: () => void;
    genderList: string[];
    selectedGender: string;
    setSelectedGender: (val: string) => void;
    occupation: Education[];
    education: Education[];
    income: Education[];
    occupationId: number | null;
    setOccupationId: (val: number | null) => void;
    educationId: number | null;
    setEducationId: (val: number | null) => void;
    incomeId: number | null;
    setIncomeId: (val: number | null) => void;
    cities: Option[] | [];
    cityId: number | null;
    setCityId: (value: number | null) => void;
    statusList: { id: number, value: string }[]
}

export default function FilterForDownloads({
    openModal,
    setOpenModal,
    setStartDate,
    endDate,
    setEndDate,
    resetFilter,
    cityId,
    statusList,
    setStatus
}: FilterForDownloadsInterface) {
    const [_endDate, _setEndDate] = useState<string>(endDate);
    const [_startDate, _setStartDate] = useState<string>(endDate);
    const [_selectedGender, _setSelectedGender] = useState<string>("");
    const [_status, _setStatus] = useState<number | null>(null)

    const handleReset = () => {
        resetFilter();
        _setEndDate("");
        _setStartDate("");
        setOpenModal(false);
        _setStatus(null);
    };

    return (
        <Dialog open={openModal} onClose={() => setOpenModal(false)} PaperProps={{ sx: { borderRadius: 3 } }}>
            <Box sx={{ width: 400, p: 2 }}>
                <FilterDialogHeader title="Filter Surveys" onClose={() => setOpenModal(false)} onReset={handleReset} />
                <Box sx={{ maxHeight: 400, overflow: "auto scroll" }}>
                        <Typography fontSize={16} fontWeight="600" mb={1}>
                            Status
                        </Typography>
                        <Box>
                            {statusList?.map((item) => {
                                return (
                                    <PillToggleButton
                                        key={item.id}
                                        label={item.value}
                                        active={_status === item?.id}
                                        onClick={() => {
                                            if (_status === item?.id) {
                                                _setStatus(null);
                                            } else {
                                                _setStatus(item?.id);
                                            }
                                        }}
                                    />
                                );
                            })}
                        </Box>

                        <Divider sx={{ mt: 2, mb: 1 }} />

                        {/* {_dropdownOption({
                            title: "State",
                            placeholder: "Search for State",
                            options: states,
                            selectedId: _stateId,
                            onSelect: (id) => {
                                _setStateId(id);
                            },
                        })}
                        {_dropdownOption({
                            title: "City",
                            placeholder: "Select City",
                            selectedId: _cityId,
                            onSelect: (id) => {
                                _setCityId(id);
                            },
                            options:
                                cities.map((city) => {
                                    return { id: city._id, name: city.name };
                                }) || [],
                        })}
                        {_dropdownOption({
                            title: "Filter by Occupation",
                            placeholder: "Search for Occupation",
                            options: occupation,
                            selectedId: _occupationId,
                            onSelect: (id) => {
                                _setOccupationId(id);
                            },
                        })}
                        {_dropdownOption({
                            title: "Filter by Education",
                            placeholder: "Search for Education",
                            options: education,
                            selectedId: _educationId,
                            onSelect: (id) => {
                                _setEducationId(id);
                            },
                        })}
                        {_dropdownOption({
                            title: "Filter by Personal Income",
                            placeholder: "Search for Personal Income",
                            options: income,
                            selectedId: _incomeId,
                            onSelect: (id) => {
                                _setIncomeId(id);
                            },
                        })} */}
                        {_dateRange({
                            title: "Date Range",
                            setEndDate: _setEndDate,
                            setStartDate: _setStartDate,
                            startDate: _startDate,
                            endDate: _endDate,
                        })}
                        <FilterDialogFooter
                            onCancel={() => setOpenModal(false)}
                            onApply={() => {
                                setStartDate(_startDate);
                                setEndDate(_endDate);
                                setOpenModal(false);
                                setStatus(_status);
                            }}
                        />
                </Box>
            </Box>
        </Dialog>
    );

    function _dropdownOption({
        title,
        placeholder,
        options,
        selectedId,
        onSelect,
    }: {
        title: string;
        placeholder: string;
        options: { id: number; name: string; }[];
        selectedId: number | null;
        onSelect: (id: number | null) => void;
    }) {
        return (
            <Box pt={2} pb={1}>
                <Typography fontSize={16} fontWeight="600">
                    {title}
                </Typography>
                <Box pt={1} pb={2} display="flex" flexDirection="row">
                    <Autocomplete
                        fullWidth
                        // multiple
                        value={options?.find((option) => selectedId === option?.id)}
                        onChange={(e, value) => {
                            onSelect(value?.id || null);
                        }}
                        options={options}
                        getOptionLabel={(option) => option?.name}
                        // defaultValue={[{ title: "The Godfather", year: 1972 }]}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label={placeholder}
                                placeholder={placeholder}
                            />
                        )}
                    />
                </Box>
                <Divider />
            </Box>
        );
    }

    function _dateRange({
        title,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
    }: {
        title: string;
        startDate: string;
        setStartDate: (value: string) => void;
        endDate: string;
        setEndDate: (value: string) => void;
    }) {
        return (
            <Box pt={2} pb={1}>
                <Typography fontSize={16} fontWeight="600">
                    {title}
                </Typography>
                <Box pt={1} pb={2} display="flex" flexDirection={"column"}>
                    <DatePicker
                        label="Start Date"
                        format="DD-MM-YYYY"
                        disableFuture
                        value={startDate ? dayjs(startDate, "YYYY-MM-DD") : null}
                        onChange={(value: Dayjs | null) => {
                            setStartDate(value?.format("YYYY-MM-DD") || "");
                        }}
                        slotProps={{ desktopPaper: { elevation: 3 } }}
                        sx={{
                            "& .MuiSvgIcon-root": {
                                fill: "#990099", // Replace with your desired color
                            },
                        }}
                    />
                    <Box p={1}></Box>
                    <DatePicker
                        label="End Date"
                        format="DD-MM-YYYY"
                        disableFuture
                        value={endDate ? dayjs(endDate, "YYYY-MM-DD") : null}
                        onChange={(value: Dayjs | null) => {
                            setEndDate(value?.format("YYYY-MM-DD") || "");
                        }}
                        slotProps={{ desktopPaper: { elevation: 3 } }}
                        sx={{
                            "& .MuiSvgIcon-root": {
                                fill: "#990099", // Replace with your desired color
                            },
                        }}
                    />
                </Box>
            </Box>
        );
    }
}
